import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";
import { Loading, PageHeader, StatusPill } from "../../components/Shared";

export default function ServicesAdmin() {
  const [services, setServices] = useState(null);
  const [form, setForm] = useState({ name: "", category: "partner", description: "", price_note: "", city: "Jaipur" });
  const [showForm, setShowForm] = useState(false);
  const load = () => api.get("/admin/services").then((r) => setServices(r.data));
  useEffect(() => { load().catch(() => setServices([])); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/services", form); toast.success("Service added"); setShowForm(false); setForm({ name: "", category: "partner", description: "", price_note: "", city: "Jaipur" }); load(); }
    catch (err) { toast.error(formatErr(err)); }
  };
  const toggle = async (s) => { await api.patch(`/admin/services/${s.id}`, { active: !s.active }); load(); };
  if (!services) return <Loading />;
  return (
    <div data-testid="admin-services">
      <PageHeader title="Services" sub="Configure service types, pricing notes, city and availability."
        actions={<button onClick={() => setShowForm(!showForm)} className="p1-btn-primary !px-5 !py-2.5" data-testid="add-service-btn"><Plus className="h-4 w-4" /> Add Service</button>} />
      {showForm && (
        <form onSubmit={submit} className="p1-card mb-6 grid gap-4 p-5 sm:grid-cols-2" data-testid="service-form">
          <input className="p1-input" placeholder="Service name *" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="svc-name" />
          <select className="p1-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} data-testid="svc-category">
            <option value="included">Included in ParentOne plan</option><option value="partner">Verified partner (charged separately)</option>
          </select>
          <input className="p1-input" placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} data-testid="svc-description" />
          <input className="p1-input" placeholder="Price note (e.g. ₹700/session)" value={form.price_note} onChange={(e) => setForm({ ...form, price_note: e.target.value })} data-testid="svc-price" />
          <div className="sm:col-span-2"><button className="p1-btn-primary !px-5 !py-2.5" data-testid="svc-submit">Save Service</button></div>
        </form>
      )}
      <div className="overflow-hidden rounded-2xl border border-stone-200 bg-white">
        <table className="w-full text-sm" data-testid="services-table">
          <thead className="bg-stone-50 text-left text-xs uppercase tracking-wider text-stone-500">
            <tr><th className="p-3">Service</th><th className="p-3">Category</th><th className="p-3">City</th><th className="p-3">Price note</th><th className="p-3">Status</th><th className="p-3"></th></tr>
          </thead>
          <tbody className="divide-y divide-stone-100">
            {services.map((s) => (
              <tr key={s.id} data-testid={`service-row-${s.id}`}>
                <td className="p-3 font-medium text-stone-800">{s.name}</td>
                <td className="p-3">{s.category === "included" ? <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-800">Included</span> : <span className="rounded-full bg-terracotta-soft px-2 py-0.5 text-xs font-semibold text-terracotta">Partner</span>}</td>
                <td className="p-3 text-stone-500">{s.city}</td>
                <td className="p-3 text-stone-500">{s.price_note}</td>
                <td className="p-3"><StatusPill status={s.active ? "active" : "closed"} /></td>
                <td className="p-3 text-right"><button onClick={() => toggle(s)} className="text-xs font-semibold text-emerald-900 hover:underline" data-testid={`toggle-service-${s.id}`}>{s.active ? "Deactivate" : "Activate"}</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
